import { NoteAdd, Add } from '@/components/icons';
import { Button } from '@/components/ui/button';

interface BuilderMobileAddBarProps {
    disabled?: boolean;
    onAddQuestion: () => void;
    onAddSection: () => void;
}

export function BuilderMobileAddBar({
    disabled,
    onAddQuestion,
    onAddSection,
}: BuilderMobileAddBarProps) {
    return (
        <div className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-background/95 p-3 shadow-elevation-2 backdrop-blur xl:hidden">
            <div className="mx-auto grid max-w-5xl grid-cols-2 gap-2">
                <Button type="button" onClick={onAddQuestion} disabled={disabled}>
                    <Add className="size-4" />
                    Pergunta
                </Button>
                <Button type="button" variant="surface" onClick={onAddSection} disabled={disabled}>
                    <NoteAdd className="size-4" />
                    Seção
                </Button>
            </div>
        </div>
    );
}
